<template lang="pug">
  include ./../../vuek/mixins.pug

  +b.t-map
    +e.SVG.svg(
      :width="width",
      :height="height",
    )
    +e.text(v-if="activeCountry" v-bind:style="{ left: (mouseX + 20) + 'px', top: mouseY + 'px' }") {{activeCountry}}
</template>


<script>
import { mapGetters } from 'vuex';
import * as topojson from 'topojson-client';
import d3 from '@/tools/d3/d3';
import margin from '../../mixins/margin';
import geo from '../../data/world.json';

export default {
  name: 't-map',

  mixins: [
    margin,
  ],

  data() {
    return {
      svg: null,
      lines: null,
      activeCountry: '',
      width: 0,
      height: 0,

      mouseX: 0,
      mouseY: 0,
    };
  },

  props: {
    // Датасет для отображения
    dataSet: {
      type: Array,
      default: () => [],
    },
  },


  computed: {
    padded() {
      const width = this.width - this.margin.left - this.margin.right;
      const height = this.height - this.margin.top - this.margin.bottom;
      return { width, height };
    },

    ...mapGetters({
      content: 'getContent',
      lng: 'lng',
    }),
  },

  mounted() {
    window.addEventListener('resize', this.onResize);
    window.addEventListener('mousemove', this.onMouseMove);
    this.onResize();
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
    window.removeEventListener('mousemove', this.onMouseMove);
  },

  watch: {
    width: function widthChanged() {
      this.initialize();
      // this.update();
    },

    dataSet: function dataChange() {
      this.updateData();
    },
  },

  methods: {
    onMouseMove(event) {
      this.mouseX = event.clientX;
      this.mouseY = event.clientY;
    },

    onResize() {
      this.width = this.$el.offsetWidth;
      this.height = this.$el.offsetHeight;
    },

    initialize() {
      this.svg = d3.select(this.$el.querySelector('.t-map__svg'))
        .attr('width', this.padded.width)
        .attr('height', this.padded.height);

      this.lines = d3.select('.t-info__lines');

      this.chart = this.svg.select('.t-rating__chart');
      this.overlay = this.svg.select('.t-rating__overlay-container');

      this.draw();
    },

    draw() {
      // Удаление всех детей у ноды
      this.chart.selectAll('*').remove();
      this.overlay.selectAll('*').remove();

      this.drawMap();
    },

    drawMap() {
      const self = this;
      const colorScale = d3.scaleLinear()
        .domain([0, 25, 40, 55, 70, 85, 100])
        .range(['#a41d29', '#a41d29', '#d73127', '#f36d44', '#fdf8c1', '#fdf8c1', '#fddf90']);

      const projection = d3.geoRobinson()
        .scale(148)
        .rotate([352, 0, 0])
        .translate([this.width / 2, this.height / 2]);

      const path = d3.geoPath().projection(projection);

      this.svg.append('g')
        .attr('class', 'countries')
        .selectAll('path')
        .data(geo.features)
        .enter()
        .append('path')
        .attr('d', path)
        .style('fill', (d) => {
          let color = '#eee';
          const c = this.dataSet.find(item => item.ISO3 === d.id);
          if (c) {
            color = colorScale(c.CPIScore);
          }
          return color;
        })
        .style('stroke', 'white')
        .style('opacity', 0.8)
        .style('stroke-width', 0.3)
        .on('mouseover', (d) => {
          const c = self.dataSet.find(item => item.ISO3 === d.id);
          const id = d.id;
          d3.select('.t-info__lines')
            .selectAll('.line')
            .style('opacity', '0.3')
            .filter(dd => dd.ISO3 === id)
            .style('stroke', dd => (dd.CPIScore >= dd.CPIScorePrev ? '#25b34b' : 'red'))
            .style('stroke-width', '2')
            .style('opacity', '1');

          d3.select('.t-info__lines')
            .selectAll('.line-text-left')
            .filter(dd => dd.ISO3 === id)
            .style('opacity', '1');

          d3.select('.t-info__lines')
            .selectAll('.line-text-right')
            .filter(dd => dd.ISO3 === id)
            .style('opacity', '1');

          if (c) {
            let country = '';

            if (self.lng === 'ua') {
              country = c.name_ua;
            } else {
              country = c.country;
            }

            self.activeCountry = `${c.rank}. ${country} - ${c.CPIScore} ${self.content.bals} 100.`;
          } else {
            self.activeCountry = '';
          }
        })
        .on('mouseout', () => {
          self.activeCountry = '';
          d3.select('.t-info__lines')
            .selectAll('.line')
            .style('stroke', 'white')
            .style('stroke-width', '0.3')
            .style('opacity', '1');

          d3.select('.t-info__lines')
            .selectAll('.line-text-left')
            .style('opacity', '0');

          d3.select('.t-info__lines')
            .selectAll('.line-text-right')
            .style('opacity', '0');
        });

      this.svg.append('path')
        .datum(topojson.mesh(geo.features, (a, b) => a.id !== b.id))
        .attr('class', 'names')
        .attr('d', path);
    },
  },
};
</script>

<style lang="scss">
@import '../../scss/styles';

.t-map {
  position: relative;
  width: 100%;
  height: 100%;

  &__container {
    display: flex;
    position: relative;
  }

  &__svg {
    position: absolute;
    top: 0;
    left: 0;
  }

  &__text {
    position: fixed;
    display: inline-block;
    color: white;
    background-color: $color-blue;
    font-family: $hfont;
    padding: 0px 8px;
    font-size: 14px;
    line-height: 22px;
    padding-top: 4px;
    font-weight: 400;
    border-radius: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TMap/TMap.vue